import React from 'react';

class Button extends React.Component {
  render() {
    return (
      <button>大哥牛逼不</button>
    )
  }
}

export default Button;
